import React, {useContext, useEffect, useMemo, useState} from "react";
import Sidebar from "./Sidebar";
import {CustomTooltip} from "../../../styles/TooltipStyles";
import {TOOLTIP_COLORS} from "../../../styles/Variables";
import {
  getAuth,
  getIdToken,
  getIdTokenResult,
  onAuthStateChanged,
  ParsedToken,
} from "firebase/auth";
import {
  GetAuthDetailsByToken,
  GetEduateDetailsByAuthId,
} from "../../Auth/queries/queries";
import {useLazyQuery} from "@apollo/client";
import {
  GetAuthDetailsByTokenData,
  GetAuthDetailsByTokenVars,
  GetEduateDetailsByAuthIdResult,
} from "../../Auth/queries/types";
import {emptyMessage, UserType} from "../../../utils/constants";
import {AppContext} from "../../../context/context";
import {payloadTypes} from "../../../context/reducer";
import {useNavigate, useParams} from "react-router-dom";
import {GetByAuthIdVars} from "../../../utils/commonQueryTypes";
import {
  GetUserRightsByEmpIdResult,
  GetUserRightsByEmpIdVar,
} from "../../modules/asset/users/AssignRights/queries/types";
import {msgType} from "../../../utils/types";
import MessageModal from "../../../customComponents/MessageModal";
import {empType, Operation} from "../../../utils/Enum.types";
import {GetUserRightsByEmpId} from "../../modules/asset/users/AssignRights/queries/queries";
import {GetEmployeeByAuthId} from "../../modules/asset/users/queries/queries";
import {GetEmployeeByAuthIdResult} from "../../modules/asset/users/queries/types";
import {TableType} from "../../modules/customer/companies/queries/types";
interface Props {
  children: React.ReactNode;
}
const DashBoard: React.FC<Props> = ({children}) => {
  const auth = getAuth();
  const [claims, setClaims] = useState<ParsedToken>({});
  const {state, dispatch} = useContext(AppContext);
  const [message, setMessage] = useState<msgType>(emptyMessage);
  const navigate = useNavigate();
  const [GetDetailsByIdToken] = useLazyQuery<
    GetAuthDetailsByTokenData,
    GetAuthDetailsByTokenVars
  >(GetAuthDetailsByToken);

  const [GetEmpDetails, {data: empData}] = useLazyQuery<
    GetEmployeeByAuthIdResult,
    GetByAuthIdVars
  >(GetEmployeeByAuthId);

  const [GetEduateDetails, {data}] = useLazyQuery<
    GetEduateDetailsByAuthIdResult,
    GetByAuthIdVars
  >(GetEduateDetailsByAuthId);

  const [GetRights] = useLazyQuery<
    GetUserRightsByEmpIdResult,
    GetUserRightsByEmpIdVar
  >(GetUserRightsByEmpId);

  const findUserRights = (token: string, customerID: number, empID: number) => {
    GetRights({
      variables: {
        customerID,
        empID,
        token,
      },
    }).then(({data}) => {
      if (data && data.GetUserRightsByEmpId) {
        const {tableLevel, rightsDetails} = data.GetUserRightsByEmpId;

        if (rightsDetails.length) {
          switch (tableLevel) {
            case TableType.COMPANY:
              if (window.location.pathname === "/") {
                navigate(`/userlogin/${customerID}/company/`);
              }
              break;
            case TableType.SUBSIDIARY:
              if (window.location.pathname === "/") {
                navigate(`/userlogin/${customerID}/subsidiary`);
              }
              break;
            case TableType.SITE:
              if (window.location.pathname === "/") {
                navigate(`/userlogin/${customerID}/assetsite`);
              }
              break;
            case TableType.JUNCTION:
              if (window.location.pathname === "/") {
                navigate(`/userlogin/${customerID}/junctions`);
              }
              break;
          }
        } else {
          setMessage({
            flag: true,
            message: "No rights Assigned",
            operation: Operation.NONE,
          });
        }
      }
    });
  };

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        getIdToken(user).then((token) => {
          GetDetailsByIdToken({
            variables: {token},
          }).then(({data}) => {
            if (data) {
              const {authGroupType} = data.GetAuthDetailsByToken;

              switch (authGroupType) {
                case UserType.EMPLOYEE:
                  GetEmpDetails({
                    variables: {
                      auth_id: data.GetAuthDetailsByToken.id,
                      token,
                    },
                  }).then(({data}) => {
                    if (data && data.GetEmployeeByAuthId) {
                      dispatch({
                        type: payloadTypes.SET_EMPLOYEE_LOGIN_ID,
                        payload: {
                          empLoginId: Number(data.GetEmployeeByAuthId.id),
                        },
                      });
                      dispatch({
                        type: payloadTypes.SET_CUST_ID,
                        payload: {
                          customerId: data.GetEmployeeByAuthId.customerID,
                        },
                      });
                      dispatch({
                        type: payloadTypes.EMP_SUB_TYPE,
                        payload: {
                          empSubType: data.GetEmployeeByAuthId.empType,
                        },
                      });

                      if (
                        data.GetEmployeeByAuthId.empType === empType.SYS_ADMIN
                      ) {
                        if (window.location.pathname === "/") {
                          navigate(
                            `/${data.GetEmployeeByAuthId.customerID}/company`
                          );
                        }
                      } else if (window.location.pathname === "/")
                        navigate(
                          `/${data.GetEmployeeByAuthId.customerID}/dashboard`
                        );
                    }
                  });
                  // GetStaffDetailsByAuthId({
                  //   variables: {
                  //     token,
                  //     auth_id: data.GetAuthDetailsByToken.id,
                  //   },
                  // }).then(({ data: EmpData }) => {
                  //   if (EmpData) {
                  //     dispatch({
                  //       type: payloadTypes.SET_EMP_LOGIN_ID,
                  //       payload: {
                  //         empLoginId: EmpData.GetEmployeeByAuthId.id,
                  //       },
                  //     });
                  //     if (
                  //       EmpData.GetEmployeeByAuthId.emp_type ===
                  //       UserType.CASHIER
                  //     )
                  //       dispatch({
                  //         type: payloadTypes.SET_SUB_USER_TYPE,
                  //         payload: {
                  //           subUserType: UserType.CASHIER,
                  //         },
                  //       });
                  //     isUserValid({
                  //       variables: {
                  //         token,
                  //         inst_id:
                  //           InstId ?? EmpData.GetEmployeeByAuthId.inst_id,
                  //         input: {
                  //           user_type: UserType.EMPLOYEE,
                  //           id: EmpData.GetEmployeeByAuthId.id,
                  //         },
                  //       },
                  //     }).then(({ data }) => {
                  //       if (data && !data?.ValidateAuthUser) {
                  //         // handleSignOut();
                  //       }
                  //       if (EmpData) {
                  //         GetConfigDetails({
                  //           variables: {
                  //             token,
                  //             inst_id: state.InstId,
                  //             input: {
                  //               config_query_type:
                  //                 SwConfigQueryType.BY_CONFIG_KEY,
                  //               str_value: "ENABLE_PAYMENT_DUE_PAGE",
                  //               int_value: 0,
                  //             },
                  //           },
                  //         }).then(({ data: PaymentDueData }) => {
                  //           if (
                  //             PaymentDueData &&
                  //             PaymentDueData.GetSwConfigVariables[0]
                  //               .config_boolean_value
                  //           ) {
                  //             setPaymentModal(true);
                  //           }
                  //         });
                  //       }
                  //       if (EmpData) {
                  //         GetEmpPwdStatus({
                  //           variables: {
                  //             token,
                  //             inst_id: EmpData.GetEmployeeByAuthId.inst_id!,
                  //             pr_emp_id: EmpData.GetEmployeeByAuthId.id,
                  //           },
                  //         }).then(({ data: PwdStatusData }) => {
                  //           if (
                  //             PwdStatusData &&
                  //             PwdStatusData.CheckEmpResetPwdStatus.status
                  //           ) {
                  //             setPaswordModal(true);
                  //             setPasswordMesg(
                  //               PwdStatusData?.CheckEmpResetPwdStatus.message
                  //             );
                  //           }
                  //         });
                  //       }
                  //     });

                  //     if (
                  //       EmpData.GetEmployeeByAuthId.just_login_acct &&
                  //       EmpData.GetEmployeeByAuthId.emp_type ===
                  //         UserType.TEACHER
                  //     ) {
                  //       window.location.pathname === "/" &&
                  //         state.InstId &&
                  //         navigate(`/${state.InstId}/academics`);
                  //     } else if (
                  //       EmpData.GetEmployeeByAuthId.just_login_acct &&
                  //       EmpData.GetEmployeeByAuthId.emp_type ===
                  //         UserType.CASHIER
                  //     ) {
                  //       window.location.pathname === "/" &&
                  //         state.InstId &&
                  //         navigate(
                  //           `/${state.InstId}/accounts/cashierdashboard`
                  //         );
                  //     } else if (
                  //       EmpData.GetEmployeeByAuthId.just_login_acct &&
                  //       (EmpData.GetEmployeeByAuthId.emp_type ===
                  //         UserType.CLERK ||
                  //         EmpData.GetEmployeeByAuthId.emp_type ===
                  //           UserType.ACCOUNTANT)
                  //     ) {
                  //       window.location.pathname === "/" &&
                  //         state.InstId &&
                  //         navigate(`/${state.InstId}/accounts/`);
                  //     } else {
                  //       window.location.pathname === "/" &&
                  //         state.InstId &&
                  //         navigate(`/${state.InstId}/admissions`);
                  //     }
                  //   }
                  // });
                  break;
                case UserType.EDUATE:
                  GetEduateDetails({
                    variables: {
                      token,
                      auth_id: data.GetAuthDetailsByToken.id,
                    },
                  }).then(({data}) => {
                    if (data && data.GetEduateDetailsByAuthId) {
                      dispatch({
                        type: payloadTypes.SET_EDUATE_ID,
                        payload: {
                          eduateId: data.GetEduateDetailsByAuthId.id,
                        },
                      });
                      // isUserValid({
                      //   variables: {
                      //     token,
                      //     inst_id: InstId,
                      //     input: {
                      //       user_type: UserType.EDUATE,
                      //       id: data.GetEduateDetailsByAuthId.id,
                      //     },
                      //   },
                      // }).then(({ data }) => {
                      //   if (data && !data?.ValidateAuthUser) {
                      //     handleSignOut();
                      //   }
                      // });
                      // window.location.pathname === "/" &&
                      //   navigate("/eduate/customer/list");
                    }
                  });
                  break;
                default:
                  break;
              }
            }
          });
        });

        getIdTokenResult(user).then((IdTokenResult) => {
          const {claims} = IdTokenResult;
          setClaims(claims);
        });
      }
    });
  }, [
    // isUserValid,
    GetDetailsByIdToken,
    // studentDetails,
    // GetStaffDetailsByAuthId,
    // parentDetails,
    // getOwnerDetails,
    GetEduateDetails,
    data,
    empData,
    dispatch,
    GetEmpDetails,
    // navigate,
    // state.InstId,
    // InstId,
    state.customerId,
    state.empLoginId,
    // state.subUserType,
    // GetEmpPwdStatus,
    // GetStdPwdStatus,
    // eduateDetails,
    // GetConfigDetails,
  ]);

  return (
    <>
      <div className="container-fluid g-0 h100">
        <div className="row g-0 h-100 ">
          <div className="col-auto g-0 h-100">
            <Sidebar claims={claims} />
          </div>
          <section className="col g-0 h-100 responsive-layout">
            <div className="main">{children}</div>
          </section>
        </div>
        <footer className="container-fluid fixed-bottom">
          <div className="row g-0">
            <div className="col footer__lost-login">
              {/* <span>
                User Last Login:
                {auth.currentUser && auth.currentUser.metadata.lastSignInTime
                  ? toStandardDate(auth.currentUser.metadata.lastSignInTime)
                  : EMPTY_STRING}
              </span> */}
            </div>

            <div className="col-6 footer_version">
              <CustomTooltip
                title="Active Finacial Year"
                placement="top"
                slotProps={{
                  tooltip: {
                    sx: {
                      bgcolor: TOOLTIP_COLORS.GREY,
                      "& .MuiTooltip-arrow": {
                        color: TOOLTIP_COLORS.GREY,
                      },
                    },
                  },
                }}
              >
                <span>
                  {/* {(state.ActiveFinYr && state.ActiveFinYr.fin_yr) ||
                    CURRENT_YEAR} */}
                </span>
              </CustomTooltip>
              {/* <span>{toStandardDate(TODAY_DATE)} </span>
              <span>{time}</span> */}
              <span>
                Version <b>{process.env.React_App_Version}</b>
              </span>
            </div>
          </div>
        </footer>
      </div>
      {/* <Modal
        shouldCloseOnOverlayClick={false}
        isOpen={passwordModal}
        style={WaiveOffModalStyles}
        ariaHideApp={false}
      >
        <div className="modal-flex h-100">
          <div className="modal-flex__data h-100">
            <ResetPassword
              setPasswordModal={setPaswordModal}
              passwordMesg={passwordMesg}
            />
          </div>
          <div className="modal-flex__image"></div>
        </div>
      </Modal> */}

      <MessageModal
        handleClose={() => {
          setMessage(emptyMessage);
        }}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </>
  );
};

export default DashBoard;
